import moment from 'moment'
import React from 'react'

const OrderTrackingHistory = props => {
  return (
    <div style={{ marginTop: 20 }}>
      {props.events.map(event => (
        <div
          key={event.timestamp}
          style={{
            borderLeft: '2px solid',
            borderLeftColor: 'grey',
            width: '100%',
            position: 'relative',
            paddingTop: 30,
            paddingLeft: 15
          }}
        >
          {/* Green circle */}
          <div style={{ width: 8, height: 8, borderRadius: 50, backgroundColor: '#28D094', position: 'absolute', left: -5, top: 38 }} />
          <div style={{ fontSize: 14, fontWeight: '600' }}>{event.description}</div>
          <div style={{ fontSize: 14 }}>{`${event.location} (${event.country})`}</div>
          <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2, display: 'flex', gap: 10 }}>
            {moment(event.timestamp).format('D/M/YYYY, HH:mm')}
          </div>
        </div>
      ))}
    </div>
  )
}

export default OrderTrackingHistory
